<template>
  <div class="daylyAssessment-listsup">
        <list-layout-paper>
            <div slot="header-search">
                <m-search-list ref="searchList" :searchId="'searchListConfig'" :list="searchConfig.searchList" @onSearchChange="searchChange">
                    <div slot="table-module-btn" class="btn-box">
                        <reportExport #default="{ submit }" reportCode="SRM_PERFOR_SUPPLIER_CENTRE" style="margin-right:10px">
                            <el-tooltip v-has="'08010004'" effect="dark" content="导出" placement="bottom">
                                <span>
                                    <el-button icon="el-icon-download" size="mini" @click="exportFunc(submit)"></el-button>
                                </span>
                            </el-tooltip>
                        </reportExport>
                        <el-tooltip effect="dark" content="列配置" placement="bottom" class="header-button-btn">
                            <el-button icon="el-icon-setting" size="mini" @click="colDispose"></el-button>
                        </el-tooltip>
                    </div>
                </m-search-list>
            </div>
            <div slot="list">
                <el-table :data="daylist" border stripe ref="multipleTable" class="tab-list" height="200"
                    @row-dblclick="reviewDetail" @select-all="selectFunc" @select="selectFunc">
                    <el-table-column type="selection" width="55" fixed="left" :selectable="disFunc"></el-table-column>
                    <el-table-column
                        v-for="column in columnsList"
                        :key="column.prop"
                        :prop="column.prop"
                        :label="column.label"
                        :min-width="column.width?column.width : ''">
                    </el-table-column>
                    <el-table-column prop="action" label="操作" width="210" align="center" fixed="right">
                        <template slot-scope="scope">
                            <span v-has="'08010003'" v-if="scope.row.dailyStatus === '5'||scope.row.dailyStatus === '6'||scope.row.dailyStatus === '7'"
                                class="btn" @click="reviewReason(scope.row)">查看原因</span>
                            <span v-has="'08010001'" v-if="(scope.row.dailyStatus === '1'||scope.row.dailyStatus === '4') && scope.row.appealTime !== '0'"
                                class="btn" style="margin-left:10px" @click="checkFn(scope.row)">申诉</span>
                            <span v-has="'08010002'" v-if="scope.row.dailyStatus === '1'||scope.row.dailyStatus === '4'" class="btn" style="margin-left:10px" @click="sureFn(scope.row)">确认</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="footer">
                <div>
                    <span v-has="'08010001'"><el-button type="primary" size="mini" @click="batchFunc">批量申诉</el-button></span>
                </div>
                <el-pagination
                    class="text-right"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageInfo.pageNo"
                    :page-sizes="[10, 20, 30, 50, 100]"
                    :page-size="pageInfo.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount">
                </el-pagination>
            </div>
        </list-layout-paper>
        <el-dialog :visible.sync="showModal" title="列配置" @close="dialogClose">
            <configuration :checkedList="checkedList" :selectAllColumns="selectAllColumns" ref="dialog"
                @getTableConfigList="getTableConfigList" @tableConfigClose="tableConfigClose" :columnNum='columnNum'></configuration>
        </el-dialog>
        <daylidetial v-if="detialFlag" :reasonRow="reasonRow" :detialFlag='detialFlag' @closeDay="closeDay"></daylidetial>
        <daylyDailog :reasonRow="reasonRow" :showFlag='showFlag' :dictData="dictData" :title="title" :showFlagType="showFlagType" @closeDay="closeDay"></daylyDailog>
        <examineDialog v-if="isExamineDialog" :selectItem="selectItem" :dictData="dictData" :examrow="examrow" :isExamineDialog.sync="isExamineDialog" @reload="reload"></examineDialog>
    </div>
</template>
<script>
import moment from 'moment';
import searchConfig from './search.json';
import mSearchList from '../../components/searchList';
import { mapGetters } from 'vuex';
import ListLayoutPaper from '@/components/lots/listLayout/Paper';
import datajson from './data.js';
import configuration from '@/components/otpPanel/configuration-list';
import { getList } from '../../../lsrm/api/annoMana.js';
import { customerDailyAssessments, mobileDailyDetermine } from '../../../lsrm/api/achievements/daylyAssessment.js';
import daylyDailog from './daylyDailog.vue';
import examineDialog from './examineDialog.vue';
import { dictWithUrl } from '@/components/lots/api';
import daylidetial from './daylidetial.vue';
import reportExport from '@/components/lots/reportExportPlugin';
export default {
    name: 'daylyAssessment',
    components: { ListLayoutPaper, configuration, daylyDailog, examineDialog, daylidetial, reportExport, mSearchList },
    data() {
        return {
            searchConfig,
            ...datajson
        };
    },
    mounted() {
        if (this.$route.query.dailyStatus) {
            this.searchInfo.dailyStatus = this.$route.query.dailyStatus;
        }
        this.defaultSelectAll = true;
        this.setConfigColumn();
        this.searchInfo.supplierCode = this.$store.state.supplier.supplierCode;
        dictWithUrl('SYS_BMS_NEW_MIP_STATUS,SRM_PERFOR_DAILY_STATUS_SU,SRM_PERFOR_BUSINESS_CATEGORY,SRM_BUSYNESS_TYPE_BACKGROUND,SRM_PERFOR_OPERATE_TYPE').then(item => {
            this.dictData = item.data;
            this.daylistFunc();
        });
    },
    methods: {
        selectFunc(data) {
            this.selectItem = data;
        },
        disFunc(row) {
            if ((Number(row.dailyStatus) === 1 || Number(row.dailyStatus) === 4) && row.appealTime !== '0') {
                return 1;
            } else {
                return 0;
            }
        },
        dateTimes(startTimes) {
            return moment(startTimes).format('YYYY-MM-DD HH:mm:ss');
        },
        exportFunc(submit) {
            this.isFirstSearch && this.$refs.searchList.onSearchChange();
            this.searchInfo.supplierCode = this.$store.state.supplier.supplierCode;
            submit(this.searchInfo);
            this.isFirstSearch = false;
        },
        searchChange(data) {
            if (data.dateRange && data.dateRange.length) {
                data.startDate = this.dateTimes(data.dateRange[0]);
                data.endDate = this.dateTimes(data.dateRange[1]);
                delete data.dateRange;
            }
            this.pageInfo.pageNo = 1;
            this.searchInfo = { ...data };
            this.daylistFunc();
        },
        sureFn(row) {
            const par = {
                confirmUserCode: this.$store.state.supplier.supplierCode,
                confirmUserName: this.$store.state.supplier.supplierNameCn,
                id: row.id,
                version: row.version
            };
            mobileDailyDetermine(par).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('成功确认！');
                    this.daylistFunc();
                }
            });
        },
        getcompanycode(res) {
            this.searchInfo.companyCode = res.companyCode;
        },
        getsiteCode(res) {
            this.searchInfo.siteCode = res.siteCode;
        },
        getcustomerCode(res) {
            this.searchInfo.customerCode = res.customerCode;
        },
        daylistFunc() {
            const par = { ...this.pageInfo, ...this.searchInfo, supplierCode: this.$store.state.supplier.supplierCode };
            customerDailyAssessments(par).then(res => {
                if (res && +res.code === 0) {
                    this.$emit('backreset', par);
                    this.daylist = res.data.list;
                    this.totalCount = res.data.totalCount;
                    this.conversionData(this.daylist, res.timestamp);
                    this.daylist.forEach(el => {
                        el.appealTime = this.countDown(el.countDown);
                    });
                }
            });
        },
        conversionData(list, timestamp) {
            list.forEach(el => {
                el.auditStatusText = this.dictData.SYS_BMS_NEW_MIP_STATUS[el.auditStatus];
                el.dailyStatusText = this.dictData.SRM_PERFOR_DAILY_STATUS_SU[el.dailyStatus];
                el.businessCategoryText = this.dictData.SRM_PERFOR_BUSINESS_CATEGORY[el.businessCategory];
                el.businessTypeText = this.dictData.SRM_BUSYNESS_TYPE_BACKGROUND[el.businessType];
                el.assessmentDate = el.assessmentDate.split(' ')[0];
                el.countDown = 0;
                if (el.dailyStatus === '1') {
                    el.countDown = 72 * 60 * 60 - (new Date(timestamp).getTime() - new Date(el.pushTime).getTime()) / 1000;
                } else if (el.dailyStatus === '4') {
                    el.countDown = 48 * 60 * 60 - (new Date(timestamp).getTime() - new Date(el.rejectTime).getTime()) / 1000;
                }
            });
        },
        countDown(maxtime) {
            if (maxtime > 0) {
                const hour = Math.floor(maxtime / 60 / 60) < 10 ? '0' + Math.floor(maxtime / 60 / 60) : Math.floor(maxtime / 60 / 60);
                const minutes = Math.floor(maxtime / 60 % 60) < 10 ? '0' + Math.floor(maxtime / 60 % 60) : Math.floor(maxtime / 60 % 60);
                const seconds = Math.floor(maxtime % 60) < 10 ? '0' + Math.floor(maxtime % 60) : Math.floor(maxtime % 60);
                --maxtime;
                return hour + ':' + minutes + ':' + seconds;
            } else {
                return '0';
            }
        },
        checkFn(row) { // 审批
            this.isExamineDialog = true;
            this.examrow = row;
        },
        batchFunc() { // 复核
            if (!this.selectItem.length) {
                this.$message.warning('请选择需要复核的选项！');
                return;
            }
            this.isExamineDialog = true;
        },
        reviewDetail(row) {
            this.detialFlag = true;
            this.reasonRow = row;
        },
        reviewReason(row) {
            this.showFlag = true;
            this.title = '查看原因';
            this.showFlagType = 1;
            this.reasonRow = row;
        },
        closeDay(val) { // 关闭弹窗
            this.showFlag = val;
            this.detialFlag = false;
        },
        handleSizeChange(val) {
            this.pageInfo.pageSize = val;
            this.daylistFunc();
        },
        handleCurrentChange(val) {
            this.pageInfo.pageNo = val;
            this.daylistFunc();
        },
        colDispose() {
            this.showModal = true;
        },
        getbusinessCategory(val) {
            this.searchInfo.businessCategory = val;
        },
        getdailyStatus(val) {
            this.searchInfo.dailyStatus = val;
        },
        getAccountEntity(val) {
            this.bankInfo = val;
        },
        dialogClose() {
            this.showModal = false;
        },
        setConfigColumn() {
            const menu = { subResources: JSON.parse(JSON.stringify(this.menus)) };
            this.deepMenu(menu);
            const pramas = {
                'moduleCode': this.resourceCode,
                'subjectType': 'tenderList'
            };
            getList.get(pramas).then(res => {
                const datas = res && res.data.configNameCn ? res.data.configNameCn.split(',') : [];
                const columnsList = [];
                if (!datas.length || this.defaultSelectAll) {
                    this.defaultSelectAll = true;
                    this.selectAllColumns.map(data => {
                        columnsList.push(data);
                    });
                    const tabelConfigListArr = [];
                    const tabelConfigNameArr = [];
                    this.columnsList.forEach(el => {
                        tabelConfigListArr.push(el.label);
                        tabelConfigNameArr.push(el.prop);
                    });
                    const tabelConfigList = tabelConfigListArr.join(',');
                    const tabelConfigName = tabelConfigNameArr.join(',');
                    this.getTableConfigList(tabelConfigList, tabelConfigName);
                } else {
                    datas.map(title => {
                        this.selectAllColumns.map(data => {
                            if (data.label === title) {
                                columnsList.push(data);
                            }
                        });
                    });
                }
                this.columnsList = columnsList;
                const arr = [];
                this.columnsList.forEach(el => {
                    arr.push(el.label);
                });
                this.checkedList = arr.join(',');
            });
        },
        getTableConfigList(tabelConfigList, tabelConfigName) {
            this.showModal = false;
            const pramas = {
                'configName': tabelConfigName,
                'configNameCn': tabelConfigList,
                'subjectType': 'dayAssess',
                'moduleCode': this.resourceCode
            };
            getList.post(pramas).then(() => {});
            const datas = tabelConfigList.split(',');
            const columnsList = [];
            datas.map(title => {
                this.selectAllColumns.map(data => {
                    if (data.label === title) {
                        columnsList.push(data);
                    }
                });
            });
            this.columnsList = columnsList;
        },
        deepMenu(node) {
            const nodes = [];
            if (node) {
                nodes.push(node);
                const childrens = node.subResources;
                if (childrens) {
                    this.deepFunc(childrens);
                }
            }
        },
        deepFunc(childrens) {
            for (let i = 0; i < childrens.length; i++) {
                if (childrens[i].frontUrl === this.$route.path || (childrens[i].frontUrl === '/index' && this.$route.path === '/')) {
                    this.resourceCode = childrens[i].resourceCode;
                    this.frontUrl = childrens[i].frontUrl;
                } else {
                    this.deepMenu(childrens[i]);
                }
            }
        },
        tableConfigClose() {
            this.showModal = false;
        },
        reload() {
            setTimeout(() => {
                this.daylistFunc();
                this.examrow = {};
            }, '100');
        }

    },
    computed: {
        ...mapGetters(['menus', 'currentTenant', 'applicationCode'])
    }
};
</script>
<style lang="less">
.daylyAssessment-listsup {
    .el-col-3 {
        width: initial;
    }
    .list-header {
        display: initial;
        justify-content: initial;
    }
    .el-input {
        width: 162px !important;
    }
    .layout-content {
        margin: 0 !important;
        margin-top: 10px !important;
    }
    .header-search-box {
        display: flex;
    }
    .padding-left {
        margin-left: 10px;
    }
    .advan {
        width: 120px;
        display: flex;
        margin-left: 10px;
    }
    .footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
    }
    .tab-list.el-table {
        min-height: calc(~"100vh - 312px");
    }
    .btn {
        cursor: pointer;
        color: #00a9ac;
    }
    .color-f40 {
        color: #ff6600;
        margin-left: 10px;
        font-size: 16px;
        font-weight: 700;
    }
    .dayassess-topbox {
        display: flex;
        margin-bottom: 10px;
    }
    .dayassess-topbox-in {
        width: 100%;
        background: #f1f1f1;
        display: flex;
        font-size: 14px;
        padding: 10px;
        align-items: center;
    }
}
</style>